import { token } from '@zillow/constellation';
import styled from 'styled-components';

import { getLeftVerticalNavWidthStyle } from '../AppLayoutContainer/styles';

export const StyledVerticalNavigationContainer = styled.div<{ hideHeaderNavigation: boolean }>`
  position: fixed;

  height: 100%;
  ${({ hideHeaderNavigation = false }) => getLeftVerticalNavWidthStyle({ hideHeaderNavigation })}

  border-radius: 0px 0px 0px 16px;
  border-right: 1px solid ${token('colors.gray300')};
  background-color: white;
`;
